window.ja_dic = {
    'plan': 'プラン',
    'common.calendar.january': '1月',
    'common.calendar.february': '2月',
    'common.calendar.march': '3月',
    'common.calendar.april': '4月',
    'common.calendar.may': '5月',
    'common.calendar.june': '6月',
    'common.calendar.july': '7月',
    'common.calendar.august': '8月',
    'common.calendar.september': '9月',
    'common.calendar.october': '10月',
    'common.calendar.november': '11月',
    'common.calendar.december': '12月',
    'common.calendar.sunday.short': '日',
    'common.calendar.monday.short': '月',
    'common.calendar.tuesday.short': '火',
    'common.calendar.wednesday.short': '水',
    'common.calendar.thursday.short': '木',
    'common.calendar.friday.short': '金',
    'common.calendar.saturday.short': '土',
    'common.label.roomCount': '室',
    'common.label.mailAddressEmptyError': 'メールアドレスを入力してください。',
    'common.label.mailAddressCharacterCountError': 'メールアドレスは、254文字以内で入力してください。',
    'common.label.mailAddressIncorrectError': '正しいメールアドレスを入力してください。',
    'GCER001F00100.label.countryCodeEmptyError': '連絡先（国番号）を入力してください。',
    'GCER001F00100.label.countryCodeCharacterCountError': '連絡先（国番号）は、5文字以内で入力してください。',
    'GCER001F00100.label.countryCodeIncorrectError': '正しい連絡先（国番号）を入力してください。',
    'GCER001F00100.label.areaCodeCharacterCountErrorWithin5': '連絡先（市外局番）は、5文字以内で入力してください。',
    'GCER001F00100.label.areaCodeCharacterCountErrorWithin9': '連絡先（市外局番）は、9文字以内で入力してください。',
    'common.label.areaCodeIncorrectError': '正しい連絡先（市外局番）を入力してください。',
    'common.label.cityCodeCharacterCountErrorWithin4': '連絡先（市内局番）は、4文字以内で入力してください。',
    'GCER001F00100.label.cityCodeCharacterCountErrorWithin9': '連絡先（市内局番）は、9文字以内で入力してください。',
    'common.label.cityCodeIncorrectError': '正しい連絡先（市内局番）を入力してください。',
    'common.label.subscriberNumberCharacterCountErrorWithin4': '連絡先（加入者番号）は、4文字以内で入力してください。',
    'GCER001F00100.label.subscriberNumberCharacterCountErrorWithin9': '連絡先（加入者番号）は、9文字以内で入力してください。',
    'common.label.subscriberNumberIncorrectError': '正しい連絡先（加入者番号）を入力してください。',
    'GCER001F00100.label.areaCodeEmptyError': '連絡先（市外局番）を入力してください。',
    'GCER001F00100.label.cityCodeEmptyError': '連絡先（市内局番）を入力してください。',
    'GCER001F00100.label.subscriberNumberEmptyError': '連絡先（加入者番号）を入力してください。',
    'common.label.reservationNumberEmptyError': '予約番号を入力してください。',
    'common.label.reservationNumberCharacterCountError': '予約番号は、19文字以内で入力してください。',
    'common.label.passwordEmptyError': 'パスワードを入力してください。',
    'common.label.passwordCharacterCountError': 'パスワードは、64文字以内で入力してください。',
    'common.label.authenticationError': '認証実行時にエラーが発生しました。認証画面をリロードし再度認証を実施ください。',
    'common.label.snsAuthenticationFail': 'SNS認証に失敗しました。',
    'GCER001F00100.label.failSnsLogin': 'SNSログインに失敗しました。',
    'GCER001F00100.label.areaCodeCharacterCountErrorWithin3': '連絡先（市外局番）は、3文字以内で入力してください。',
    'common.label.unexpectedLoginError': 'ログインに想定外のエラーが発生しました。',
    'common.label.sun': '日',
    'common.label.mon': '月',
    'common.label.tue': '火',
    'common.label.wed': '水',
    'common.label.thu': '木',
    'common.label.fri': '金',
    'common.label.sat': '土',
    'common.label.gender.male': '男性',
    'common.label.gender.female': '女性',
    'common.label.gender.other': 'その他',
    'common.label.adult': '大人',
    'common.label.guestCount': '名',
    'common.label.comma': '、',
    'common.label.others': 'その他',
    'common.label.yen': '円',
    'common.label.paymentFailMessage': '決済失敗しました。システム管理者にご連絡ください。',
    'common.label.mailAddressIncorrectFormatError' :  'メールアドレスは正しいメールアドレスの書式で入力してください。',
    'common.label.welcomeInformation1-1': 'ウェルカムメールとは、ご宿泊の1週間前に、',
    'common.label.welcomeInformation1-2': 'ご予約内容を再度お伝えするメールです。',
    'common.label.welcomeInformation2' :  '※但し、ご宿泊の3日前にも同様のメールが送信されます。',
    'common.label.welcomeInformation3' :  '　そちらのメールは必ずお客様に送られますので、ご了承ください。',
    'common.label.thankYouInformation' :  'サンキューメールとは、ご宿泊後に送信されるメールです。',
    'common.label.chargeDetails': '料金明細',
    'common.label.nightNumber': '泊目',
    'common.label.roomNumber': '室目',
    'common.label.memberDiscount': '会員値引き',
    'common.label.subtotal': '小計',
    'common.label.totalRoomRate': '合計',
    'common.label.pointYenEquivalent': 'ポイント',
    'common.label.pointBalanceAmount':'所持ポイント数',
    'common.label.usableUnit.point': '({0}ポイント単位)',
    'common.label.usableUnit.point.help': '{0}ポイント単位で利用可能です。',
    'common.label.usableMaxLimit.point': '～{0}ポイント利用可能です。',
    'common.label.usableMinLimit.point': '{0}ポイント～利用可能です。',
    'common.label.usableRange.point': '{0}～{1}ポイント利用可能です。',
    'common.label.pointToGrantSuffix.point': '{0} ポイント',
    'common.label.use': '利用する',
    'common.label.useAll': 'すべて利用する',
    'coupon.message.applyCode' : 'クーポンを追加しました。',
    'coupon.message.getCoupon' : 'クーポンを獲得しました。',
    'coupon.message.getCoupon.failed' : 'クーポンを獲得できませんでした。',
    'GRES006F02600.label.lodgingNumChangeCautionWord': '※人数の追加はできません。追加したい場合は予約のお取り直しをお願いいたします。',
    'GRES006F02600.label.lodgingNumPriceEmptyCautionWord': '指定された宿泊人数合計での予約を受け付けておりません。',
    'GRES006F02600.label.lodgingDateNumChangeCautionWord': '※増泊はできません。増加したい場合は予約のお取り直しをお願いいたします。',
    'GRES006F02600.label.optionChangeWord': '※予約受付期間外のため選択できません',
    'GRES006F02600.label.kanaInformation': 'ひらがなで入力してください。',
    'GRES006F02600.label.mailInformation1': '入力ミスを防ぐため、2ヶ所に同じメールアドレスを入力してください。',
    'GRES006F02600.label.mailInformation2': '携帯メールアドレスを入力される場合は、メールフィルター設定にご注意ください。',
    'GRES006F02600.label.mailInformation3': 'インターネットからのメールを受信できない設定にされている場合、予約確認のメールをお受け取りいただくことができません。',
    'GRES006F02600.label.contactInformation': '半角数字のみ入力してください。',
    'common.label.addressZipMark': '〒',
    'GRES015F04300.label.reservationAcceptanceSuspension': '申し訳ございません。現在、予約の受付は停止させていただいております。',
    'GRES015F04300.label.planAcceptanceSuspension': '申し訳ございません。現在、ご指定のプランの受付は停止させていただいております。',
    'GRES015F04300.label.roomAcceptanceSuspension': '申し訳ございません。現在、ご指定のお部屋の受付は停止させていただいております。',
    'GRES001F02100.label.returnPlanList' : 'プラン一覧に戻る',
    'GRES001F02100.validation.emptyNameError' : 'お名前は必須項目です。特殊記号、環境依存文字を除いて入力してください。',
    'GRES001F02100.validation.wrongNameError' : '特殊記号、環境依存文字を除いて入力してください。',
    'GRES001F02100.validation.emptyNameKanaError' : 'ふりがなは必須項目です。ひらがなで入力してください。',
    'GRES001F02100.validation.wrongNameKanaError' : 'ひらがなで入力してください。',
    'GRES001F02100.validation.emptyMailAddressError' : 'メールアドレスは必須項目です。入力してください。',
    'GRES001F02100.validation.wrongMailAddressError' : '有効な形式で入力してください。',
    'GRES001F02100.validation.emptyMailAddressConfirmError' : 'メールアドレスは必須項目です。入力してください。',
    'GRES001F02100.validation.unmatchMailAddressConfirmError' : 'メールアドレスが一致するように入力してください。',
    'GRES001F02100.validation.emptyTelError' : 'ご連絡先は必須項目です。半角数字で入力してください。',
    'GRES001F02100.validation.wrongTelError' : '半角数字で入力してください。',
    'GRES001F02100.validation.tooShortTelAreaError' : '市外局番は 2文字以上5文字以内の半角数字でご入力ください。',
    'GRES001F02100.validation.tooLongTelError' : '7文字以上15文字以内の半角数字でご入力ください。',
    'GRES001F02100.validation.emptyLodgerGender' : '性別は必須項目です。選択してください。',
    'GRES001F02100.validation.emptyPassword' : 'パスワードは必須項目です。半角英数（大・小文字を含む）8~64桁で入力してください。',
    'GRES001F02100.validation.wrongPassword' : '半角英数（大・小文字を含む）8~64桁で入力してください。',
    'GRES001F02100.validation.emptyBirthday' : '生年月日は必須項目です。選択してください。',
    'GRES001F02100.validation.notRequiredEmptyBirthday' : '生年月日を選択してください。',
    'GRES001F02100.validation.emptyZipCode' : '郵便番号は必須項目です。半角数字で入力してください。',
    'GRES001F02100.validation.wrongZipCode' : '半角数字で入力してください。',
    'GRES001F02100.validation.emptyAddressPrefectures' : '住所は必須項目です。都道府県を選択してください。',
    'GRES001F02100.validation.emptyAddress' : '住所は必須項目です。入力してください。',
    'GRES001F02100.validation.emptyCreditCardNo' : 'カード番号は必須項目です。半角数字14~16桁で入力してください。',
    'GRES001F02100.validation.wrongCreditCardNo' : '半角数字14~16桁で入力してください。',
    'GRES001F02100.validation.emptySecurityCode' : 'セキュリティコードは必須項目です。半角数字3桁または4桁で入力してください。',
    'GRES001F02100.validation.wrongSecurityCode' : '半角数字3桁または4桁で入力してください。',
    'GRES001F02100.validation.emptyCreditCardName' : 'カード名義は必須項目です。入力してください。',
    'GRES001F02100.validation.wrongCreditCardName' : '有効な形式で入力してください。',
    'GRES001F02100.validation.emptyCreditCardExpire' : 'カード有効期限は必須項目です。選択してください。',
    'GRES001F02100.validation.wrongCreditCardExpire' : '過去の日付が選択されています。未来の日付を選択してください。',
    'GRES001F02100.validation.tooLongTextArea' : '200文字以内でご入力ください。',
    'GRES001F02100.validation.emptyContractCompany' : '必須項目です。入力してください。',
    'GRES001F02100.validation.emptyContractCompanyPassword' : '契約企業パスワードは必須項目です。入力してください。',
    'GRES001F02100.validation.wrongContractCompanyPassword' : '半角英数記号で入力してください。',
    'GRES001F02100.validation.unmatchLodgerGender' : 'ご予約の人数と一致するように選択してください。',
    'GRES001F02100.validation.emptyQuestionTextAnswer' : '必須項目です。入力してください。',
    'GRES001F02100.validation.tooLongQuestionTextAnswer' : '200文字以内でご入力ください。',
    'GRES001F02100.validation.emptyQuestionSelectAnswer' : '必須項目です。選択してください。',
    'GRES001F02100.validation.emptyQuestionCheckboxAnswer' : '必須項目です。選択してください。',
    'GRES001F02100.validation.couponCodeError' : '入力したコードのクーポンが見つかりません。入力内容をご確認ください。',
    'GRES001F02100.validation.couponCodeDuplicatedError' : 'すでに追加済みのクーポンです。',

    'coupon.label.more': '詳細を見る▼',
    'coupon.label.close': '詳細を見る▲',

    'coupon.banner.title.member': '会員登録すると',
    'coupon.banner.title': '割引クーポンでおトクに予約ができます！',
    'coupon.banner.title.button': '詳しくはこちら ▶',
    'coupon.modal.title': '会員登録でお得なクーポンがご利用いただけます',
    'coupon.modal.title.member': '配布中のクーポン一覧',
    'coupon.modal.caution': 'クーポンの獲得・利用には、クーポンごとに獲得条件や利用条件があります。',
    'coupon.modal.desc.1': 'クーポンの割引は宿泊料金に対して適用されます。追加オプション料金は割引対象外となります。',
    'coupon.modal.desc.2': '獲得したクーポンは、予約時に最もお得な内容・組み合わせのものが自動で利用されます。',
    'coupon.modal.desc.3': 'クーポンは配布予定枚数の終了や予算等の都合により、早期に終了する場合があります。',
    'coupon.modal.desc.4': '予約のタイミングによっては、獲得済みでもご利用いただけないことがあります。',
    'coupon.modal.membership': 'すでに会員登録済みの方は',
    'coupon.modal.memberLogin': 'ログイン',
    'coupon.modal.memberRegister': '会員登録する',
    'coupon.modal.has.otherCoupons': '他の日程で利用できるクーポン',
    'coupon.badge.couponTarget': 'クーポン対象',
    'coupon.badge.banner.title': 'おトクなクーポンを獲得する',

    'coupon.label.code': '（{{code}}）',
    'coupon.label.discountAmount.upper': '予約の合計から',
    'coupon.label.discountAmount.upper_false': '1名もしくは1室あたり※',
    'coupon.label.discountAmount': '{{amount, number}}円値引',
    'coupon.label.discountAmount_rate': '{{amount, number}}％割引',
    'coupon.label.discountAmount.has.zeroDiscount': '特典',
    'coupon.label.canUseTogether_true': '他のクーポンとの併用可能',
    'coupon.label.canUseTogether_false': '他のクーポンとの併用不可',
    'coupon.label.discountLimit': '割引上限{{amount, number}}円',
    'coupon.label.discountLimit_plan': '1泊1名当たり割引上限{{amount, number}}円',
    'coupon.label.fromTotalBookings.not': '※プランによって、1泊1名もしくは1泊1室あたりの料金から値引きになります。',
    'coupon.label.useQuantityLimit': '先着利用{{amount, number}}枚まで',
    'coupon.label.targetPlans': '対象プラン：',
    'coupon.label.availableMonths': '獲得から{{months}}ヶ月',
    'coupon.label.expiredAt': '有効期限：',
    'coupon.label.neverExpires': '期限なし',
    'coupon.label.stayAt': '宿泊対象期間：',
    'coupon.label.periodRange': '{{- day.start}}～{{- day.end}}',
    'coupon.label.periodRangeCheck': '{{- day.start}}チェックイン～{{- day.end}}チェックアウト',
    'coupon.label.unavailableDays': '除外曜日：',
    'coupon.label.unavailablePeriod': '除外期間：',
    'coupon.label.useCondition': '{{amount, number}}円以上の予約で利用可能',
    'coupon.label.remainingTimes': '{{amount, number}}回まで利用可能（残り{{remains, number}}回）',
    'coupon.label.remainingTimes.limit': '{{amount, number}}回まで利用可能',
    'coupon.label.remainingTimes.one': '{{amount, number}}回のみ利用可能 ',
    'coupon.label.remainingTimes.noLimit': '何度でも利用可能',
    'coupon.label.acquired': '獲得済み',
    'coupon.label.acquiring': '獲得する',
    'coupon.message.unable.useAmountLimit' : 'キャンペーン終了のため、ご利用いただけません。',
    'coupon.message.unable.useQuantityLimit' : 'キャンペーン終了のため、ご利用いただけません。',
    'coupon.message.unable.ended' : 'キャンペーン終了のため、ご利用いただけません。',
    'coupon.message.unable.notApplied' : '利用予定のクーポンとは併用できません。',

    'common.message.temporaryError': '一時的なエラーが発生しました。ページを再読み込みして更新してください。',
    'common.label.required': '必須',
};
